import SessionEventProto from "../session-event-proto"
// import {NEW_CHAT_MESSAGE_REACTION} from "../../model2/message-reaction/const"

export default class SessionEvent_ChatMessageDelta extends SessionEventProto {

    private header : {
        chatMessage     : any
        isBulkUpdate    : boolean
    }

    constructor(sessionEvent:any) {
        super(sessionEvent)
        this.header     = {
            chatMessage     : sessionEvent['chat-message'],
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    async process() {
        if (this.isDifferentCompany()) return false

        // Tut  nado FIX - eto general DELTA - a reactions eto odin iz cases tol'ko !!!

        // gd.bus.triggerEvent(NEW_CHAT_MESSAGE_REACTION, this.sessionEvent)

        gd.modelBus.newUpdate('chat-message', this.method, this.header.chatMessage.id, this.data, this.header);
    }
}